import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import {
    StaticPageWrapper,
    StaticPageInnerWrapper,
    HeaderWrapper,
    TitleWrapper,
    HeaderCloseIcon,
} from './CasinoBannersSidebar.style';
import { useCommon } from 'src/domains/common/Common';

export const CasinoBannersSidebar = observer('CasinoBannersSidebar', (): JSX.Element | null => {
    const common = useCommon();
    const appCasinoState = AppCasinoState.get(common);
    const { bannerStore, redirectState } = appCasinoState;

    const banner = bannerStore.sidebarTermsActiveBanner;

    return (
        <StaticPageWrapper data-test='casino-banner-sidebar-container'>
            <HeaderWrapper data-test='casino-banner-sidebar-header'>
                <TitleWrapper>Terms &amp; Conditions</TitleWrapper>
                <HeaderCloseIcon onClick={redirectState.redirectWithoutAccountParam} />
            </HeaderWrapper>
            {banner === null ? (
                <StaticPageInnerWrapper>Something went wrong.</StaticPageInnerWrapper>
            ) : (
                <StaticPageInnerWrapper
                    data-test='casino-banner-sidebar-body'
                    dangerouslySetInnerHTML={{ __html: banner.terms_full }}
                />
            )}
        </StaticPageWrapper>
    );
});
